/**
 * 图片放置 API — 审核/替换正文中的内嵌图片
 */
const API_BASE_URL = process.env.REACT_APP_API_URL ?? '';

export interface ImagePlacement {
  id: number;
  chapter_uid: string;
  marker_hash: string;
  image_id: number | null;
  source: 'search' | 'generate' | 'manual';
  query_text: string;
  position: number;
  image?: {
    id: number;
    original_name: string;
    file_path: string;
    ai_description: string;
  } | null;
}

export const imagePlacementApi = {
  list: async (projectId: number): Promise<ImagePlacement[]> => {
    const token = localStorage.getItem('token');
    const res = await fetch(
      `${API_BASE_URL}/api/projects/${projectId}/image-placements`,
      { headers: token ? { Authorization: `Bearer ${token}` } : {} }
    );
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  },

  update: async (projectId: number, placementId: number, imageId: number | null) => {
    const token = localStorage.getItem('token');
    const res = await fetch(
      `${API_BASE_URL}/api/projects/${projectId}/image-placements/${placementId}?image_id=${imageId ?? ''}`,
      {
        method: 'PUT',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      }
    );
    return res.json();
  },

  // 新增：按 slot ID（marker_hash）更新 — 稳定、可靠
  updateBySlot: async (projectId: number, slotId: string, imageId: number | null) => {
    const token = localStorage.getItem('token');
    const res = await fetch(
      `${API_BASE_URL}/api/projects/${projectId}/image-placements/by-slot/${slotId}?image_id=${imageId ?? ''}`,
      {
        method: 'PUT',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      }
    );
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  },

  batch: async (projectId: number, action: string) => {
    const token = localStorage.getItem('token');
    const res = await fetch(
      `${API_BASE_URL}/api/projects/${projectId}/image-placements/batch?action=${action}`,
      {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      }
    );
    return res.json();
  },
};
